import { createBrowserHistory } from 'history';
import { makeStore } from './Redux/Reducer';

export const history = createBrowserHistory();
export const store = makeStore(history);
